import { NgModule } from '@angular/core';
import { IntakeFormPage } from 'pages/intake-form/intake-form';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [IntakeFormPage],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class IntakeFormPageModule {}
